import { useRef, useState } from "react";
import useMediaQueries from "../../../hooks/useMediaQueries.js";
import Icon from "../../Elements/Icon/Icon.tsx";
import CustomPopup from "../../Pages/Inbox/Popups/CustomPopup.js";
import Tooltip from "../../Elements/Tooltip/Tooltip.js";
import useOnClickOutside from "../../../hooks/useOnClickOutside.js";
import Image from "components/Elements/Image/Image.tsx";
import LogoutModal from "components/Pages/LogoutModal/LogoutModal.js";
import LanguagePicker from "components/Structure/Header/LanguagePicker.js";
import { LinkToNewTab } from "../../Elements/Link/Link.js";
import { useUser } from "../../../contexts/userContext/userContext.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";

export const UserLoggedInSection = ({ isCreateForm = null, isMinified }) => {
  const { mobileCondition, tabletCondition } = useMediaQueries();

  const { getUserData, getUserProfileImage } = useUser();

  const [open, setOpen] = useState(false);
  const handleLogout = () => {
    // set logout modal
    setModal(() => <LogoutModal />);
  };

  const { setModal } = useModal();

  const { getTextByKey } = useContent();
  const select = {
    outbox: <LinkToNewTab page="inbox">{getTextByKey("inbox")}</LinkToNewTab>,
    profile: (
      <LinkToNewTab page="user/profile/account">
        {getTextByKey("profile")}
      </LinkToNewTab>
    ),
    branding: (
      <LinkToNewTab page="user/branding/cover-logo">
        {getTextByKey("branding")}
      </LinkToNewTab>
    ),
    subusers: (
      <LinkToNewTab page="user/profile/account-users">
        {getTextByKey("account-users")}
      </LinkToNewTab>
    ),
    jumbopay: (
      <LinkToNewTab page="user/jumbopay">
        {getTextByKey("jumbopay")}
      </LinkToNewTab>
    ),
    jumboembed: (
      <LinkToNewTab page="user/jumbo-forms/form-management">
        {getTextByKey("jumboembed")}
      </LinkToNewTab>
    ),
    language: (
      <div
        className="language-selector-dropdown"
        onClick={(e) => e.stopPropagation()}
      >
        <LanguagePicker textOnly />
      </div>
    ),
    break: <div className="dropdown-break"></div>,
    logout: (
      <button className="jm-link" onClick={handleLogout}>
        <i className="fas fa-power-off logout-icon"></i>
        {getTextByKey("logout")}
      </button>
    ),
  };

  if (!mobileCondition && !tabletCondition) {
    delete select["outbox"];
  }

  if (getUserData().UserCountry !== "Israel") {
    delete select["jumbopay"];
  }

  if (!getUserData().isTopUser || getUserData().subUsersCount === 0) {
    delete select["subusers"];
  }

  const ref = useRef();
  useOnClickOutside(ref, () => setOpen(false));

  const ariaLabel = `${getTextByKey("jumbomail-account-header")} ${
    getUserData().UserFirstName
  } ${getUserData().UserLastName}`;

  return (
    <>
      <button
        className="user-acc-wrapper"
        onClick={() => setOpen((prev) => !prev)}
        aria-label={ariaLabel}
        ref={ref}
        value="Open User Menu"
        aria-label="Open User Menu"
      >
        <div className="circle-wrapper">
          <Tooltip
            id={"profile-header-tooltip"}
            tooltipText={
              <>
                <div>{getTextByKey("jumbomail-account-header")}</div>
                <div>
                  {getUserData().UserFirstName} {getUserData().UserLastName}
                </div>
                <div>{getUserData().UserName}</div>
              </>
            }
            delay={0}
            bottom
          >
            <div
              className={`avatar-wrapper${
                getUserProfileImage() ? "" : " no-image"
              }`}
            >
              {getUserProfileImage() ? (
                <Image src={getUserProfileImage()} alt="" />
              ) : (
                <Icon name={"user-circled"} black />
              )}
            </div>
          </Tooltip>
          <CustomPopup showState={open} topPosition={60}>
            <div className="dropdown-content-arrow"></div>
            <div className="user-menu-list">
              {Object.keys(select).map((item) => {
                return (
                  <div className="menu-item" key={item}>
                    {select[item]}
                  </div>
                );
              })}
            </div>
          </CustomPopup>
        </div>
        {!mobileCondition &&
        !tabletCondition &&
        !isCreateForm &&
        !isMinified ? (
          <div className="user-name">{getUserData().UserFirstName}</div>
        ) : null}
        <div className={`user-dropdown-menu-icon${open ? " flipped" : ""}`}>
          <Icon
            name="newinbox/arrow-down"
            gray={isMinified}
            white={!isMinified}
            xxl
          />
        </div>
      </button>
    </>
  );
};
